let s1 = []
let s2 = []
let s3 = []
let checkbox = 'unchecked'
let checkbox2 = 'unchecked'
let checkbox3 = 'unchecked'
let checkbox4 = 'unchecked'
const valores = []
const btnSenha = document.querySelector('.btnSenha')
const char = document.getElementById('char')
const mostraSenha = document.querySelector('.gerador-senha')
const warn = document.querySelector('.warn')

export default class GeraSenha {
    addNum(){
        const num = document.getElementById('num')
        char.addEventListener('input', e => {
            const el = e.target
            let valor = el.value
            valores.push(valor)

            if(valores.length > 1) {
                valores.shift()
            }
        })

        num.addEventListener('change', e => {
            const el = e.target
            el.checked ? checkbox = 'checked' : checkbox = 'unchecked';
        })

        btnSenha.addEventListener('click', e => {
            const el = e.target
            let n
            let valor = valores[0]
            const senha = []
            if(el.classList.contains('btnSenha')) {

                if (checkbox3 == 'checked' && checkbox2 == 'checked' && checkbox4 == 'checked') {
                    if (valores[0] % 4 != 0) {
                        if (valores[0] > 8) {
                            valor = 3
                        }
                        else if (valores[0] > 4) {
                            valor = 1
                        }
                    }
                    else {
                        valor = valores[0]/4
                    }
                }
                        
                else if (checkbox3 == 'checked' && checkbox2 == 'checked' && checkbox4 == 'unchecked' ||
                    checkbox3 == 'unchecked' && checkbox2 == 'checked' && checkbox4 == 'checked' ||
                    checkbox3 == 'checked' && checkbox2 == 'unchecked' && checkbox4 == 'checked') {
                        if (valores[0] % 3 != 0) {
                            if (valores[0] > 9 && checkbox3 == 'unchecked' && checkbox2 == 'checked' && checkbox4 == 'checked' ) {
                                valor = 5
                            }
                            else if (valores[0] > 6 && checkbox3 == 'unchecked' && checkbox2 == 'checked' && checkbox4 == 'checked' ) {
                                valor = 3
                            }
                            else if (valores[0] > 9) {
                                valor = 3
                            }
                            else if (valores[0] > 7) {
                                valor = 3
                            }
                            else if (valores[0] > 4) {
                                valor = 2
                            }
                            else if (valores[0] > 3) {
                                valor = 1
                            }
                        }
                        else {
                            valor = valores[0]/3
                        }
                }

                else if (checkbox2 == 'checked' && checkbox3 == 'unchecked' && checkbox4 == 'unchecked'
                || checkbox2 == 'unchecked' && checkbox3 == 'checked' && checkbox4 == 'unchecked' ||
                checkbox4 == 'checked' && checkbox2 == 'unchecked' && checkbox3 == 'unchecked') {
                    if (valores[0] % 2 == 1) {
                        if (valores[0] == 3 && checkbox4 == 'checked') {
                            valor = 2
                        }
                        else if (valores[0] < 4) {
                            valor = 1
                        }
                        else if (valores[0] == 5 && checkbox4 == 'checked') {
                            valor = 3
                        }
                        else if (valores[0] < 6) {
                            valor = 2
                        }
                        else if (valores[0] == 7 && checkbox4 == 'checked') {
                            valor = 4
                        }
                        else if (valores[0] < 8) {
                            valor = 3
                        }
                        else if (valores[0] == 9 && checkbox4 == 'checked') {
                            valor = 5
                        }
                        else if (valores[0] < 10) {
                            valor = 4
                        }
                        else if (valores[0] == 11 && checkbox4 == 'checked') {
                            valor = 6
                        }
                        else if (valores[0] < 12) {
                            valor = 5
                        }
                    }
                    else {
                        valor = valores[0]/2
                    }
                }

                for(let i = valor; i > 0; i--){
                    n = Math.floor(Math.random() * (10 - 0) + 0)
                    senha.push(n)
                }
                s1 = [...senha]
                if(valores[0] > 12 || valores[0] < 0) return
                else if (checkbox === 'checked' && checkbox2 === 'unchecked' && checkbox3 === 'unchecked' && checkbox4 === 'unchecked') mostraSenha.innerText = senha.join('')
                else return
            }
        })

    }

    addUppercase(){
        const letrasM = ['A','B','C','D','F','G','H','I','J','K','L','M','N','O','P','Q','R','S','T','U','V','W','X','Y','Z']
        const uppercase = document.getElementById('uppercase')

        char.addEventListener('input', e => {
            const el = e.target
            let valor = el.value
            valores.push(valor)
            if(valores.length > 1) {
                valores.shift()
            }
        })

        uppercase.addEventListener('change', e => {
            const el = e.target
            el.checked ? checkbox2 = 'checked' : checkbox2 = 'unchecked';
        })
        
        btnSenha.addEventListener('click', e => {
            const el = e.target
            let n
            let valor = valores[0]
            const senha2 = []

            if(el.classList.contains('btnSenha')) {

                if (checkbox == 'checked' && checkbox3 == 'checked' && checkbox4 == 'checked') {
                    if (valores[0] == 9) {
                        valor = 1
                    }
                    else if (valores [0] == 10) {
                        valor = 2
                    }
                    else if (valores [0] == 12) {
                        valor = 4
                    }
                    else valor = valores[0]/4
                }

                else if (checkbox3 == 'checked' && checkbox == 'checked' && checkbox4 == 'unchecked' ||
                    checkbox4 == 'checked' && checkbox == 'checked' && checkbox3 == 'unchecked' ||
                    checkbox4 == 'checked' && checkbox3 == 'checked' && checkbox == 'unchecked' ) {
                        if (valores[0] % 3 != 0) {
                            if (valores[0] > 10 && checkbox3 == 'checked' && checkbox == 'checked' && checkbox4 == 'unchecked')  {
                                valor = 3
                            }
                            if (valores[0] > 7 && checkbox3 == 'unchecked' && checkbox == 'checked' && checkbox4 == 'checked')  {
                                valor = 3
                            }
                            else if (valores[0] > 6 && checkbox3 == 'checked' && checkbox == 'checked' && checkbox4 == 'unchecked' || checkbox4 == 'checked' && checkbox == 'checked' && checkbox3 == 'unchecked' )  {
                                valor = 2
                            }
                            else if (valores[0] > 9) {
                                valor = 3
                            }
                            else if (valores[0] > 7) {
                                valor = 3
                            }
                            else if (valores[0] > 4 && checkbox4 == 'checked' && checkbox3 == 'checked' && checkbox == 'unchecked' ) {
                                valor = 2
                            }
                            else if (valores[0] > 3) {
                                valor = 1
                            }
                        }
                        else {
                            valor = valores[0]/3
                        }
                }

                else if (checkbox == 'checked' && checkbox3 == 'unchecked' && checkbox4 == 'unchecked'
                || checkbox == 'unchecked' && checkbox3 == 'checked' && checkbox4 == 'unchecked' ||
                checkbox4 == 'checked' && checkbox == 'unchecked' && checkbox3 == 'unchecked') {
                    if (valores[0] % 2 == 1 && checkbox3 == 'checked') {
                        if (valores[0] < 4) {
                            valor = 1
                        }
                        else if (valores[0] < 6) {
                            valor = 2
                        }
                        else if (valores[0] < 8) {
                            valor = 3
                        }
                        else if (valores[0] < 10) {
                            valor = 4
                        }
                        else if (valores[0] < 12) {
                            valor = 5
                        }
                    }
                    else if (valores[0] % 2 != 0 && checkbox3 == 'unchecked') {
                        if (valores[0] > 2) {
                            valor = 2
                        }
                        if (valores[0] > 4) {
                            valor = 3
                        }
                        if (valores[0] > 6) {
                            valor = 4
                        }
                        if (valores[0] > 8) {
                            valor = 5
                        }
                        if (valores[0] > 10) {
                            valor = 6
                        }
                    }
                    else {
                        valor = valores[0]/2
                    }
                }


                for(let i = valor; i > 0; i--){
                    n = Math.floor(Math.random() * (25 - 0) + 0)
                    let el = letrasM[n]
                    senha2.push(el)
                }
                s2 = [...senha2]
                let senha = senha2.join('') + s1.join('')
                if(valores[0] > 12 || valores[0] < 0) return
                else if (checkbox2 === 'checked' && checkbox === 'checked'  && valores[0] >= 2 && checkbox3 === 'unchecked' && checkbox4 === 'unchecked') mostraSenha.innerText = senha
                else if (checkbox2 === 'checked' && checkbox === 'unchecked' && checkbox3 === 'unchecked' && checkbox4 === 'unchecked') mostraSenha.innerText = senha2.join('')
                else return
            }
        })
    }
    addLowercase(){
        const letrasm = ['a','b','c','d','f','g','h','i','j','k','l','m','n','o','p','q','r','s','t','u','v','w','x','y','z']
        const lowercase = document.getElementById('lowercase')
    
        char.addEventListener('input', e => {
            const el = e.target
            let valor = el.value
            valores.push(valor)
            if(valores.length > 1) {
                valores.shift()
            }
        })
    
        lowercase.addEventListener('change', e => {
            const el = e.target
            el.checked ? checkbox3 = 'checked' : checkbox3 = 'unchecked';
        })
     
        btnSenha.addEventListener('click', e => {
            const el = e.target
            let n
            let valor = valores[0]
            const senha3 = []
            if(el.classList.contains('btnSenha')) {

                if (checkbox == 'checked' && checkbox2 == 'checked' && checkbox4 == 'checked') {
                    valor = valores[0]/4
                    if(valores[0] == 6 || valores[0] == 5) {
                        valor = 1
                    }
                }

                else if (checkbox2 == 'checked' && checkbox == 'checked' && checkbox4 == 'unchecked' ||
                    checkbox4 == 'checked' && checkbox == 'checked' && checkbox2 == 'unchecked' ||
                    checkbox4 == 'checked' && checkbox2 == 'checked' && checkbox == 'unchecked') {
                        if (valores[0] % 3 != 0) {
                            if (valores[0] > 9) {
                                valor = 5
                            }
                            else if (valores[0] > 6) {
                                valor = 3
                            }
                            else if (valores[0] > 3) {
                                valor = 2
                            }
                        }
                        else {
                            valor = valores[0]/3
                        }
                }
                
                else if (checkbox == 'checked' && checkbox2 == 'unchecked' && checkbox4 == 'unchecked' ||
                    checkbox2 == 'checked' && checkbox4 == 'unchecked' && checkbox == 'unchecked' ||
                    checkbox4 == 'checked' && checkbox2 == 'unchecked' && checkbox4 == 'unchecked' ) {

                    if (valores[0] % 2 != 0 && checkbox == 'checked' || valores[0] % 2 != 0 && checkbox2 == 'checked') {
                        if (valores[0] < 5) {
                            valor = 2
                        }
                        else if (valores[0] < 6) {
                            valor = 3
                        }
                        else if (valores[0] < 8) {
                            valor = 4
                        }
                        else if (valores[0] < 10) {
                            valor = 5
                        }
                        else if (valores[0] < 12) {
                            valor = 6
                        }
                    }
                    else {
                        valor = valores[0]/2
                    }
                }



                for(let i = valor; i > 0; i--){
                    n = Math.floor(Math.random() * (25 - 0) + 0)
                    let el = letrasm[n]
                    senha3.push(el)
                }
                
                s3 = [...senha3]

                let senha = senha3.join('') + s1.join('')
                let senha2 = senha3.join('') + s2.join('')
                let senha4 = senha3.join('') + s1.join('') + s2.join('')

                if(valores[0] > 12 || valores[0] < 0) return    
                else if (checkbox3 === 'checked' && checkbox2 === 'checked' && checkbox === 'checked' && checkbox4 === 'unchecked' && valores[0] > 2) mostraSenha.innerText = senha4
                else if (checkbox3 === 'checked' && checkbox === 'checked' && valores[0] >= 2 && checkbox2 === 'unchecked' && checkbox4 === 'unchecked') mostraSenha.innerText = senha
                else if (checkbox3 === 'checked' && checkbox2 === 'checked' && valores[0] >= 2 && checkbox === 'unchecked' && checkbox4 === 'unchecked') mostraSenha.innerText = senha2
                else if (checkbox3 === 'checked' && checkbox === 'unchecked' && checkbox2 === 'unchecked' && checkbox4 === 'unchecked') mostraSenha.innerText = senha3.join('')
                else return
            }
        })
    }
    addSymbol(){
        const symbols = ['*','!','(',')','[',']','-','.','?','_','`','~',';','$','#','%','^','&','+','=']
        const symbol = document.getElementById('symbol')
    
        char.addEventListener('input', e => {
            const el = e.target
            let valor = el.value
            valores.push(valor)
            if(valores.length > 1) {
                valores.shift()
            }
        })
    
        symbol.addEventListener('change', e => {
            const el = e.target
            el.checked ? checkbox4 = 'checked' : checkbox4 = 'unchecked';
        })
    
        btnSenha.addEventListener('click', e => {
            const el = e.target
            let n
            const senha4 = []
            
            if(el.classList.contains('btnSenha')) {
                let valor = valores[0]

                if (checkbox == 'checked' && checkbox2 == 'checked' && checkbox3 == 'checked') {
                    if (valores[0] == 5) {
                        valor = 1
                    }
                    else if (valores[0] > 5) {
                        valor = 2
                    }
                    else valor = valores[0]/4
                }

                else if (checkbox2 == 'checked' && checkbox == 'checked' && checkbox3 == 'unchecked' ||
                    checkbox == 'checked' && checkbox3 == 'checked' && checkbox2 == 'unchecked' ||
                    checkbox3 == 'checked' && checkbox2 == 'checked' && checkbox == 'unchecked') {
                    if (valores[0] % 3 != 0) {
                        
                        if (valores[0] > 10) {
                            valor = 3
                        }
                        else if (valores[0] > 6) {
                            valor = 2
                        }
                        else if (valores[0] > 3) {
                            valor = 1
                        }
                    }
                    else {
                        valor = valores[0]/3
                    }
                }
                
                else if (checkbox == 'checked' && checkbox2 == 'unchecked' && checkbox3 == 'unchecked' ||
                    checkbox2 == 'checked' && checkbox3 == 'unchecked' && checkbox == 'unchecked' ||
                    checkbox3 == 'checked' && checkbox2 == 'unchecked' && checkbox == 'unchecked' ) {
                    if (valores[0] % 2 == 1) {
                        if (valores[0] < 4) {
                            valor = 1
                        }
                        else if (valores[0] < 6) {
                            valor = 2
                        }
                        else if (valores[0] < 8) {
                            valor = 3
                        }
                        else if (valores[0] < 10) {
                            valor = 4
                        }
                        else if (valores[0] < 12) {
                            valor = 5
                        }
                    }
                    else {
                        valor = valores[0]/2
                    }
                }

                for(let i = valor; i > 0; i--){
                    n = Math.floor(Math.random() * (20 - 0) + 0)
                    let el = symbols[n]
                    senha4.push(el)
                }

                let senha = senha4.join('') + s1.join('')
                let senha2 = senha4.join('') + s2.join('')
                let senha3 = senha4.join('') + s3.join('')
                let senha5 = senha4.join('') + s1.join('') + s2.join('')
                let senha6 = senha4.join('') + s1.join('') + s3.join('')
                let senha7 = senha4.join('') + s2.join('') + s3.join('')
                let senha8 = senha4.join('') + s2.join('') + s3.join('') + s1.join('')
                warn.style.display = 'none'

                if(valores[0] > 12) {
                    warn.style.display = 'block'
                    return
                }
                else if (checkbox4 === 'checked' && checkbox3 === 'checked' && checkbox2 === 'checked' && checkbox === 'checked' && valores[0] > 3) mostraSenha.innerText = senha8  
                else if (checkbox4 === 'checked' && checkbox3 === 'checked' && checkbox2 === 'checked' && checkbox === 'unchecked' && valores[0] > 2) mostraSenha.innerText = senha7
                else if (checkbox4 === 'checked' && checkbox3 === 'checked' && checkbox2 === 'unchecked' && checkbox === 'checked' && valores[0] > 2) mostraSenha.innerText = senha6
                else if (checkbox4 === 'checked' && checkbox3 === 'unchecked' && checkbox2 === 'checked' && checkbox === 'checked' && valores[0] > 2) mostraSenha.innerText = senha5
                else if (checkbox4 === 'checked' && checkbox3 === 'checked' && checkbox2 === 'unchecked' && checkbox === 'unchecked' && valores[0] >= 2 && checkbox2 === 'unchecked') mostraSenha.innerText = senha3
                else if (checkbox4 === 'checked' && checkbox3 === 'unchecked' && checkbox2 === 'checked' && valores[0] >= 2 && checkbox === 'unchecked') mostraSenha.innerText = senha2
                else if (checkbox4 === 'checked' && checkbox3 === 'unchecked' && checkbox === 'checked' && checkbox2 === 'unchecked' && valores[0] >= 2) mostraSenha.innerText = senha
                else if (checkbox4 === 'checked' && checkbox3 === 'unchecked' && checkbox === 'unchecked' && checkbox2 === 'unchecked') mostraSenha.innerText = senha4.join('')
                else return
            }
        })
    }
}
